/**
 * Date constants and utilities for UpWaste
 */

/**
 * Maximum date for pricing rules and other indefinite periods.
 * Using a practical year (2099) instead of JavaScript's theoretical max date.
 * This provides a good balance between:
 * - Being far enough in the future for practical purposes
 * - Being a human-readable date
 * - Avoiding potential date handling issues with extremely large dates
 */
export const MAX_DATE = new Date('2099-12-31T23:59:59.999Z');

/**
 * Maximum date as ISO string for API/form usage
 */
export const MAX_DATE_ISO = MAX_DATE.toISOString();

/**
 * Maximum date formatted for HTML date inputs (YYYY-MM-DD)
 */
export const MAX_DATE_HTML = '2099-12-31';

/**
 * Checks if a date represents the maximum/indefinite date
 */
export const isMaxDate = (date: Date | string): boolean => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj.getFullYear() === 2099 && dateObj.getMonth() === 11 && dateObj.getDate() === 31;
};

/**
 * Returns the maximum date for indefinite periods
 */
export const getMaxDate = (): Date => {
  return new Date(MAX_DATE);
};
